(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahakey-x1-apple-draft"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    const root = document.querySelector('[data-ax1-root]');
    if (!root || !window.gsap || !window.ScrollTrigger || root.dataset.ax1Ready === 'true') return;
    root.dataset.ax1Ready = 'true';

    root.querySelectorAll('[data-ax1-buy]').forEach((buyLink) => {
      buyLink.addEventListener('click', (event) => {
        const purchaseSection = document.querySelector('[id^="ProductSection-"][data-section-type="product"]');
        if (!purchaseSection) return;
        event.preventDefault();
        purchaseSection.id = 'Ax1ProductPurchase';
        purchaseSection.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    gsap.registerPlugin(ScrollTrigger);
    const mm = gsap.matchMedia();
    const revealItems = root.querySelectorAll('[data-ax1-reveal]');
    const intro = gsap.timeline({ defaults: { duration: .9, ease: 'power3.out' } });
    intro.from(revealItems, { autoAlpha: 0, y: 34, stagger: .12 }).from(root.querySelector('[data-ax1-hero-media]'), { autoAlpha: 0, y: 44, scale: .94, duration: 1.2 }, '-=.45');

  mm.add({ desktop: '(min-width: 990px)', mobile: '(max-width: 989px)', reduceMotion: '(prefers-reduced-motion: reduce)' }, (context) => {
    const { desktop, reduceMotion } = context.conditions;
    if (reduceMotion) {
      gsap.set(root.querySelectorAll('[data-ax1-reveal-section], [data-ax1-card], [data-ax1-workflow-step]'), { clearProps: 'all' });
      return;
    }

    gsap.to(root.querySelector('[data-ax1-hero-media]'), {
      yPercent: -8,
      scale: .96,
      ease: 'none',
      scrollTrigger: { trigger: root.querySelector('.ax1__hero'), start: 'top top', end: 'bottom top', scrub: .8 }
    });

    ScrollTrigger.batch(root.querySelectorAll('[data-ax1-card]'), {
      start: 'top 82%',
      once: true,
      onEnter: (items) => gsap.from(items, { autoAlpha: 0, y: 46, stagger: .12, duration: .8, ease: 'power3.out' })
    });

    ScrollTrigger.batch(root.querySelectorAll('[data-ax1-reveal-section], [data-ax1-workflow-step]'), {
      start: 'top 84%',
      once: true,
      onEnter: (items) => gsap.from(items, { autoAlpha: 0, y: 40, stagger: .1, duration: .85, ease: 'power3.out' })
    });

    if (desktop) {
      const story = root.querySelector('[data-ax1-story]');
      const views = [...root.querySelectorAll('[data-ax1-view]')];
      const labels = [...root.querySelectorAll('.ax1__story-labels span')];
      const caption = root.querySelector('[data-ax1-story-caption]');
      const progress = root.querySelector('[data-ax1-story-progress]');
      let activeIndex = 0;
      const setView = (index) => {
        if (index === activeIndex) return;
        const previous = views[activeIndex];
        const next = views[index];
        previous.classList.remove('is-active');
        labels[activeIndex]?.classList.remove('is-active');
        next.classList.add('is-active');
        labels[index]?.classList.add('is-active');
        gsap.fromTo(next, { autoAlpha: 0, scale: .94 }, { autoAlpha: 1, scale: 1, duration: .55, ease: 'power2.out', overwrite: true });
        caption.textContent = next.dataset.caption;
        gsap.fromTo(caption, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: .4, ease: 'power2.out', overwrite: true });
        activeIndex = index;
      };
      gsap.set(views[0], { autoAlpha: 1, scale: 1 });
      ScrollTrigger.create({
        trigger: story,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const index = Math.min(views.length - 1, Math.floor(self.progress * views.length));
          setView(index);
          gsap.set(progress, { scaleX: self.progress });
        }
      });
    }
  });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) mm.revert();
    }, { once: true });
  };

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x1-product-landing-codex-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const splitWords = (element, text) => {
    element.innerHTML = "";
    const words = text.trim().split(/\s+/);
    words.forEach((word, index) => {
      const span = document.createElement("span");
      span.className = "x1-word";
      span.textContent = word;
      span.dataset.wordIndex = String(index);
      element.appendChild(span);
    });
    return Array.from(element.querySelectorAll(".x1-word"));
  };

  const streamWords = (words, interval = 86, delay = 0) => {
    window.setTimeout(() => {
      words.forEach((word, index) => {
        window.setTimeout(() => word.classList.add("x1-word-visible"), index * interval);
      });
    }, delay);
  };

  const initDynamicBanner = () => {
    document.querySelectorAll("[data-x1-banner]").forEach((banner) => {
      if (banner.dataset.x1BannerBound === "true") {
        return;
      }

      banner.dataset.x1BannerBound = "true";

      const prompt = banner.querySelector("[data-x1-typewriter]");
      const answer = banner.querySelector("[data-x1-stream-answer]");
      const secondary = banner.querySelector("[data-x1-scroll-response]");
      const thinking = banner.querySelector("[data-x1-thinking]");

      if (!prompt || !answer || !secondary) {
        return;
      }

      const questionText = prompt.dataset.text || "";
      const answerText = answer.dataset.text || "";
      const secondaryText = secondary.dataset.text || "";
      const answerWords = splitWords(answer, answerText);
      const secondaryWords = splitWords(secondary, secondaryText);

      let typed = 0;
      const typeInterval = Math.max(38, Math.round(1700 / Math.max(questionText.length, 1)));
      const typer = window.setInterval(() => {
        typed += 1;
        prompt.textContent = questionText.slice(0, typed);

        if (typed >= questionText.length) {
          window.clearInterval(typer);
          prompt.classList.add("x1-type-done");
          if (thinking) {
            thinking.classList.add("x1-is-hidden");
          }
          streamWords(answerWords, 96, 170);
          window.setTimeout(() => {
            banner.classList.add("x1-initial-ready");
          }, 170 + answerWords.length * 96 + 140);
        }
      }, typeInterval);

      const updateScroll = () => {
        const rect = banner.getBoundingClientRect();
        const maxTravel = Math.max(banner.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / maxTravel, 0), 1);
        const lift = Math.min(Math.max((progress - 0.14) / 0.22, 0), 1);
        const streamProgress = Math.min(Math.max((progress - 0.18) / 0.76, 0), 1);
        const visibleCount = Math.floor(streamProgress * secondaryWords.length);

        banner.style.setProperty("--x1-answer-lift", String(lift));

        secondaryWords.forEach((word, index) => {
          word.classList.toggle("x1-word-visible", index < visibleCount);
        });

        banner.classList.toggle("x1-scroll-ready", visibleCount >= secondaryWords.length);
      };

      let ticking = false;
      const scheduleUpdate = () => {
        if (ticking) {
          return;
        }
        ticking = true;
        window.requestAnimationFrame(() => {
          updateScroll();
          ticking = false;
        });
      };

      updateScroll();
      window.addEventListener("scroll", scheduleUpdate, { passive: true });
      window.addEventListener("resize", scheduleUpdate);
      document.addEventListener("shopify:section:unload", () => {
        window.removeEventListener("scroll", scheduleUpdate);
        window.removeEventListener("resize", scheduleUpdate);
      }, { once: true });
    });
  };

  const bindProductScroll = () => {
    if (window.x1ProductScrollBound === true) {
      return;
    }

    window.x1ProductScrollBound = true;

    document.addEventListener("click", (event) => {
      const button = event.target.closest('[data-x1-scroll-target="ProductSection-main"]');

      if (!button) {
        return;
      }

      const productTarget = document.getElementById("ProductSection-main");

      if (!productTarget) {
        return;
      }

      event.preventDefault();

      const header = document.getElementById("SiteHeader");
      const headerOffset = header ? header.getBoundingClientRect().height + 18 : 96;
      const targetTop = productTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: "smooth"
      });

      if (history.pushState) {
        history.pushState(null, "", "#ProductSection-main");
      }
    }, true);
  };

  const initReveal = () => {
    const section = document.querySelector("section.x1-landing");

    if (!section || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const revealItems = [
      ...section.querySelectorAll(".x1-landing__section-title, .x1-landing__intro, .x1-landing__copy, .x1-landing__strong, .x1-landing__list"),
      ...section.querySelectorAll(".x1-landing__workflow-card, .x1-landing__value-card, .x1-landing__hardware-card, .x1-landing__use-case, .x1-landing__spec-table, .x1-landing__media-panel, .x1-landing__workflow-media"),
      ...document.querySelectorAll("#ProductSection-main .product__photos, #ProductSection-main .product-single__meta, #ProductSection-main .product-single__title")
    ].filter(Boolean);

    if (!("IntersectionObserver" in window)) {
      revealItems.forEach((item) => item.classList.add("x1-is-visible"));
      return;
    }

    revealItems.forEach((item, index) => {
      if (item.dataset.x1RevealBound === "true") {
        return;
      }
      item.dataset.x1RevealBound = "true";
      item.classList.add("x1-reveal");
      if (item.matches(".x1-landing__section-title, .x1-landing__intro, .x1-landing__copy, .x1-landing__strong, .x1-landing__list, #ProductSection-main .product-single__title")) {
        item.dataset.x1Reveal = "text";
      }
      item.style.transitionDelay = `${Math.min(index % 5, 4) * 80}ms`;
    });

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("x1-is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });

    revealItems.forEach((item) => revealObserver.observe(item));
  };

  const init = () => {
    bindProductScroll();
    initDynamicBanner();
    initReveal();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x1-product-landing-codex"] && !Shopify.designMode) return;
  try {
    
(() => {
  const splitWords = (element, text) => {
    element.innerHTML = "";
    const words = text.trim().split(/\s+/);
    words.forEach((word, index) => {
      const span = document.createElement("span");
      span.className = "x1-word";
      span.textContent = word;
      span.dataset.wordIndex = String(index);
      element.appendChild(span);
    });
    return Array.from(element.querySelectorAll(".x1-word"));
  };

  const streamWords = (words, interval = 86, delay = 0) => {
    window.setTimeout(() => {
      words.forEach((word, index) => {
        window.setTimeout(() => word.classList.add("x1-word-visible"), index * interval);
      });
    }, delay);
  };

  const initDynamicBanner = () => {
    document.querySelectorAll("[data-x1-banner]").forEach((banner) => {
      if (banner.dataset.x1BannerBound === "true") {
        return;
      }

      banner.dataset.x1BannerBound = "true";

      const prompt = banner.querySelector("[data-x1-typewriter]");
      const answer = banner.querySelector("[data-x1-stream-answer]");
      const secondary = banner.querySelector("[data-x1-scroll-response]");
      const thinking = banner.querySelector("[data-x1-thinking]");

      if (!prompt || !answer || !secondary) {
        return;
      }

      const questionText = prompt.dataset.text || "";
      const answerText = answer.dataset.text || "";
      const secondaryText = secondary.dataset.text || "";
      const answerWords = splitWords(answer, answerText);
      const secondaryWords = splitWords(secondary, secondaryText);

      let typed = 0;
      const typeInterval = Math.max(38, Math.round(1700 / Math.max(questionText.length, 1)));
      const typer = window.setInterval(() => {
        typed += 1;
        prompt.textContent = questionText.slice(0, typed);

        if (typed >= questionText.length) {
          window.clearInterval(typer);
          prompt.classList.add("x1-type-done");
          if (thinking) {
            thinking.classList.add("x1-is-hidden");
          }
          streamWords(answerWords, 96, 170);
          window.setTimeout(() => {
            banner.classList.add("x1-initial-ready");
          }, 170 + answerWords.length * 96 + 140);
        }
      }, typeInterval);

      const updateScroll = () => {
        const rect = banner.getBoundingClientRect();
        const maxTravel = Math.max(banner.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / maxTravel, 0), 1);
        const lift = Math.min(Math.max((progress - 0.14) / 0.22, 0), 1);
        const streamProgress = Math.min(Math.max((progress - 0.18) / 0.76, 0), 1);
        const visibleCount = Math.floor(streamProgress * secondaryWords.length);

        banner.style.setProperty("--x1-answer-lift", String(lift));

        secondaryWords.forEach((word, index) => {
          word.classList.toggle("x1-word-visible", index < visibleCount);
        });

        banner.classList.toggle("x1-scroll-ready", visibleCount >= secondaryWords.length);
      };

      let ticking = false;
      const scheduleUpdate = () => {
        if (ticking) {
          return;
        }
        ticking = true;
        window.requestAnimationFrame(() => {
          updateScroll();
          ticking = false;
        });
      };

      updateScroll();
      window.addEventListener("scroll", scheduleUpdate, { passive: true });
      window.addEventListener("resize", scheduleUpdate);
      document.addEventListener("shopify:section:unload", () => {
        window.removeEventListener("scroll", scheduleUpdate);
        window.removeEventListener("resize", scheduleUpdate);
      }, { once: true });
    });
  };

  const bindProductScroll = () => {
    if (window.x1ProductScrollBound === true) {
      return;
    }

    window.x1ProductScrollBound = true;

    document.addEventListener("click", (event) => {
      const button = event.target.closest('[data-x1-scroll-target="ProductSection-main"]');

      if (!button) {
        return;
      }

      const productTarget = document.getElementById("ProductSection-main");

      if (!productTarget) {
        return;
      }

      event.preventDefault();

      const header = document.getElementById("SiteHeader");
      const headerOffset = header ? header.getBoundingClientRect().height + 18 : 96;
      const targetTop = productTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: "smooth"
      });

      if (history.pushState) {
        history.pushState(null, "", "#ProductSection-main");
      }
    }, true);
  };

  const initReveal = () => {
    const section = document.querySelector("section.x1-landing");

    if (!section || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const revealItems = [
      ...section.querySelectorAll(".x1-landing__section-title, .x1-landing__intro, .x1-landing__copy, .x1-landing__strong, .x1-landing__list"),
      ...section.querySelectorAll(".x1-landing__workflow-card, .x1-landing__value-card, .x1-landing__hardware-card, .x1-landing__use-case, .x1-landing__spec-table, .x1-landing__media-panel, .x1-landing__workflow-media"),
      ...document.querySelectorAll("#ProductSection-main .product__photos, #ProductSection-main .product-single__meta, #ProductSection-main .product-single__title")
    ].filter(Boolean);

    if (!("IntersectionObserver" in window)) {
      revealItems.forEach((item) => item.classList.add("x1-is-visible"));
      return;
    }

    revealItems.forEach((item, index) => {
      if (item.dataset.x1RevealBound === "true") {
        return;
      }
      item.dataset.x1RevealBound = "true";
      item.classList.add("x1-reveal");
      if (item.matches(".x1-landing__section-title, .x1-landing__intro, .x1-landing__copy, .x1-landing__strong, .x1-landing__list, #ProductSection-main .product-single__title")) {
        item.dataset.x1Reveal = "text";
      }
      item.style.transitionDelay = `${Math.min(index % 5, 4) * 80}ms`;
    });

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("x1-is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });

    revealItems.forEach((item) => revealObserver.observe(item));
  };

  const init = () => {
    bindProductScroll();
    initDynamicBanner();
    initReveal();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();

  } catch(e) { console.error(e); }
})();
})();
